import PolicyLayout from "./PolicyLayout";

export default function Privacy() {
  return (
    <PolicyLayout title="Privacy Policy" updated="March 2026" testId="privacy-page">
      <p>Pawsomeland Foundation ("we", "us", "our") respects your privacy. This Privacy Policy explains what information we collect on <strong>pawsomelandfoundation.org</strong>, how we use it, and the rights you have over it.</p>

      <h2>1. Information We Collect</h2>
      <p>When you donate or contact us, we collect:</p>
      <ul>
        <li>Your <strong>name, email, and phone number</strong> (phone is optional)</li>
        <li>The <strong>donation amount</strong> and whether it is a one-time or monthly recurring gift</li>
        <li>Optional <strong>message</strong> you leave with your donation</li>
        <li>Your <strong>PAN and address</strong>, only if you request an 80G tax certificate</li>
      </ul>
      <p>We do <strong>not</strong> collect or store your card numbers, UPI IDs, CVVs, or bank account details at any point. All payment data is handled directly by our payment gateway, Razorpay.</p>

      <h2>2. Automatically Collected Data</h2>
      <p>Like most websites, we collect basic analytics such as page views, device type, browser, and general location (country/city) through Meta Pixel and standard web logs. This helps us understand which stories and campaigns resonate with donors.</p>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To process your donation (one-time or monthly recurring) and send you a receipt</li>
        <li>To send occasional updates about the animals your donation is helping (only if you opt in)</li>
        <li>To manage and communicate about your recurring donation — including reminders before charges, and confirmations after each successful debit</li>
        <li>To respond to your enquiries and volunteering requests</li>
        <li>To meet legal, tax, and compliance obligations (including 80G reporting)</li>
      </ul>

      <h2>4. Monthly Recurring Donations &amp; Data Retention</h2>
      <p>If you opt in to a monthly recurring donation, we retain your name, email, phone, and subscription reference (from Razorpay) for as long as the subscription remains active — so we can identify you, send updates, and process cancellation on request. You can ask us to cancel your recurring donation at any time by writing to <a href="mailto:pawsomelandfoundation@gmail.com">pawsomelandfoundation@gmail.com</a>. Cancellation is typically processed within 3 working days.</p>

      <h2>5. Sharing of Information</h2>
      <p>We do not sell or rent your personal data. We share information only with:</p>
      <ul>
        <li><strong>Razorpay</strong> — for processing payments (subject to their own privacy policy)</li>
        <li><strong>Meta (Facebook)</strong> — anonymised pixel events for advertising performance</li>
        <li><strong>Tax authorities</strong> — only when legally required (e.g., 80G reporting)</li>
      </ul>

      <h2>6. Cookies</h2>
      <p>We use minimal cookies for essential functions (payment flow) and analytics (Meta Pixel). You can disable non-essential cookies in your browser settings; the donation flow will still work.</p>

      <h2>7. Data Security</h2>
      <p>Your information is transmitted over HTTPS and stored on secure servers. Access to donor information is limited to authorised team members strictly for operational purposes.</p>

      <h2>8. Your Rights</h2>
      <ul>
        <li>You can request a copy of the personal data we hold about you.</li>
        <li>You can ask us to correct or delete your data.</li>
        <li>You can withdraw consent to marketing emails at any time via the unsubscribe link, or by writing to us.</li>
        <li>You can cancel a monthly recurring donation at any time.</li>
      </ul>
      <p>To exercise any of these rights, email <a href="mailto:pawsomelandfoundation@gmail.com">pawsomelandfoundation@gmail.com</a>.</p>

      <h2>9. Children's Data</h2>
      <p>Our services are not directed to individuals under 18. We do not knowingly collect data from minors.</p>

      <h2>10. Changes to this Policy</h2>
      <p>We may update this Privacy Policy periodically. The "Last updated" date at the top will always reflect the latest revision.</p>

      <h2>11. Contact</h2>
      <p>Pawsomeland Foundation<br/>House no. 20, Kaveri Tailors, Ganesh Mandir, Chhola Road, Bhopal<br/>Email: <a href="mailto:pawsomelandfoundation@gmail.com">pawsomelandfoundation@gmail.com</a><br/>Phone: <a href="tel:+917477216753">+91 74772 16753</a></p>
    </PolicyLayout>
  );
}
